import "./import-jquery";
import "./import-bootstrap";
import "./lib/bootstrap.select.min.js";

let main = async () =>
{
    jQuery(i =>
    {
        if (window.location.pathname=="/") {
            jQuery(".navbar-panda").removeClass('navbar-white');
        }
        
        jQuery('.checkbox input:checked')
            .closest('.checkbox')
            .addClass('active');
    
        jQuery('.checkbox input')
            .change(function () {
                jQuery(this)
                    .closest('.checkbox')
                    .toggleClass('active')
            });
    
    
        /* Navbar scroll */
        jQuery(document).scroll(function()
        { 
            let scroll_pos = jQuery(this).scrollTop();
            if (scroll_pos > 132)
            {
                jQuery(".navbar-panda").addClass('navbar-white');
            }
            else
            {
                if (window.location.pathname=="/")
                {
                    jQuery(".navbar-panda").removeClass('navbar-white');
                }
            }
        });
    
        let collapse = jQuery('.collapse');
        if (collapse.length)
        {
            collapse?.collapse({
                toggle: false
            })
        }
        
    
        var sidebar = jQuery('.animated-sidebar');
        var contentArea = sidebar.closest('.row').children(':first-child');
        var contentHeight = contentArea.outerHeight();
    
        sidebar.outerHeight(contentHeight);
    
        scrollableTimer();
    });
}

main();



let scrollableTimer = function () {
    setTimeout(function () {
        var scrollable = jQuery('.scrollable-hook');
        var first = jQuery('.scrollable-hook li:first-child');
        var firstHeight = first.outerHeight();

        first.animate({
            opacity: 0
        }, 300, function () {
            scrollable.children('li').animate({
                top: -firstHeight + 'px'
            }, 500, function () {
                scrollable.append(first);

                scrollable.children('li').animate({
                    top: '0px',
                    opacity: 1
                }, 0, function () {

                });
            });

            scrollableTimer();
        });

    }, 8000);
};

let meetTheTeam = function () {
    jQuery('.who-we-are-hook').click(function (e) {
        e.preventDefault();
        var columnHook = jQuery('.who-we-are-column-hook');

        columnHook
            .addClass('col-xs-6')
            .addClass('active')
            .removeClass('col-xs-12')
            .after('<div class="loading text-center"><i class="fa fa-spin fa-5x fa-circle-o-notch"></i></div>')
        ;

        jQuery('.temp-column').remove();

        jQuery.post(jQuery(this).attr('href'), function (data) {
            jQuery('.loading').remove();
            columnHook.after('<div class="col-xs-6 temp-column">' + data + '</div>');
        });
    });
};